import React, { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Input, Label } from 'reactstrap';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface Auth {
  languageSoftware: number;
  [key: string]: any;
}

interface LanguageSelectSoftwareProps {
  auth: Auth;
  updateDefaultUserLanguages: (data: { languageSoftware: number }) => void;
}

const LanguageSelectSoftware: React.FC<LanguageSelectSoftwareProps> = ({
  auth,
  updateDefaultUserLanguages
}) => (
  <div>
    <Label className="font-weight-bold">{getTranslationKey('selectLanguageSoftware')}:</Label>
    <Input
      type="select"
      value={auth.languageSoftware}
      onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
        updateDefaultUserLanguages({
          languageSoftware: parseInt(value, 10)
        });
      }}
    >
      {Object.keys(getTranslationKey('languages') || {}).map((languageKey) => (
        <option key={languageKey} value={languageKey}>
          {getTranslationKey(`languages.${languageKey}`)}
        </option>
      ))}
    </Input>
  </div>
);

const mapStateToProps = ({ auth }: any) => ({
  auth
});

export default connect(mapStateToProps, actions)(LanguageSelectSoftware);
